import { useEffect, useState } from 'react';
import api from '../utils/api';

/**
 * Módulos Avanzados de la empresa activa (los asigna el super admin). null mientras carga.
 * Se guarda por empresa en memoria para que el menú y la pantalla no pregunten dos veces.
 */
const cache = new Map();
export default function useModulosAvanzados(emisorId) {
  const [mods, setMods] = useState(() => (emisorId && cache.get(emisorId)) || null);
  useEffect(() => {
    if (!emisorId) { setMods([]); return; }
    if (cache.has(emisorId)) { setMods(cache.get(emisorId)); return; }
    let vivo = true;
    api.get('/modulos-avanzados')
      .then(r => { const m = r.data?.data || []; cache.set(emisorId, m); if (vivo) setMods(m); })
      .catch(() => { if (vivo) setMods([]); });
    return () => { vivo = false; };
  }, [emisorId]);
  return mods;
}
